import Config from './../../config';
import Store from './../store';

// available oauth params
const TOKENS = ['access', 'refresh', 'expire'];

// return user oauth tokens and params
export function getTokens() {

    let user_tokens = {};
    TOKENS.map(i => {
        let tokenKey = `${Config.AUTH_PREFIX}${i}`;
        if (Store.get(tokenKey)) {
            user_tokens[i] = Store.get(tokenKey);
        }
        return null;
    });
    return user_tokens;
}
// add user tokens to store
export function setTokens(tokens = {}) {
    Object.keys(tokens).map(i => {
        let tokenKey = `${Config.AUTH_PREFIX}${i}`;
        Store.set(tokenKey, tokens[i]);
        return i;
    });
}


// clear all user tokens
export function clearUserTokens() {
    TOKENS.map(i => {
        let tokenKey = `${Config.AUTH_PREFIX}${i}`;
        Store.remove(tokenKey);
        return i;
    });
}



// WEBPACK FOOTER //
// ./src/utils/user/tokens.js